"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = void 0 && (void 0).__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var spaui_utils_1 = require("@tencent/spaui-utils");
var info_1 = __importDefault(require("./info"));
var spaui_1 = require("@tencent/spaui");
var classnames_1 = __importDefault(require("classnames"));
var odc_flex_1 = __importDefault(require("@tencent/odc-flex"));
var prefixCls = 'odc-alert-group';
var AlertGroupComponent = function AlertGroupComponent(props) {
  var _a;
  var data = props.data,
    _b = props.type,
    type = _b === void 0 ? 'info' : _b,
    alertProps = props.alertProps,
    _c = props.pagePosition,
    pagePosition = _c === void 0 ? 'left' : _c,
    pageProps = props.pageProps;
  var _d = __read((0, react_1.useState)(1), 2),
    page = _d[0],
    setPage = _d[1];
  var _e = __read((0, react_1.useState)(data), 2),
    currentData = _e[0],
    setCurrentData = _e[1];
  (0, react_1.useEffect)(function () {
    setCurrentData(data);
    setPage(1);
  }, [data]);
  var len = (0, react_1.useMemo)(function () {
    return currentData.length;
  }, [currentData]);
  var handleChange = (0, react_1.useCallback)(function (dir) {
    var newPage = page + dir;
    if (newPage > 0 && newPage <= len) {
      setPage(newPage);
    }
  }, [page, len]);
  var pageBar = (0, react_1.useMemo)(function () {
    if (len > 1) {
      return react_1["default"].createElement(odc_flex_1["default"], __assign({
        h: 20,
        className: (0, classnames_1["default"])('odc-alert-group-pageBar flex-none items-center gap-4', {
          'mr-8': pagePosition === 'left',
          'ml-8': pagePosition === 'right'
        })
      }, pageProps), react_1["default"].createElement(spaui_1.Button, {
        isCompound: true,
        displayType: 'text',
        className: "odc-alert-group-btn-prev",
        disabled: page === 1,
        onClick: function onClick() {
          return handleChange(-1);
        }
      }, react_1["default"].createElement(spaui_1.Icon, {
        name: "left-arrow-outlined"
      })), react_1["default"].createElement("span", {
        className: "odc-text leading-none odc-text-primary"
      }, "".concat(page, "/").concat(len)), react_1["default"].createElement(spaui_1.Button, {
        isCompound: true,
        displayType: 'text',
        className: "odc-alert-group-btn-next",
        disabled: page === len,
        onClick: function onClick() {
          return handleChange(1);
        }
      }, react_1["default"].createElement(spaui_1.Icon, {
        name: "right-arrow-outlined"
      })));
    }
    return null;
  }, [len, pagePosition, pageProps, page, handleChange]);
  var currentType = (0, react_1.useMemo)(function () {
    var _a, _b;
    return (_b = (_a = data === null || data === void 0 ? void 0 : data[page - 1]) === null || _a === void 0 ? void 0 : _a.type) !== null && _b !== void 0 ? _b : type;
  }, [type, page, data]);
  return react_1["default"].createElement("div", __assign({}, (0, spaui_utils_1.globalProps)(props, {
    className: (0, classnames_1["default"])(prefixCls, (_a = {}, _a["".concat(prefixCls, "-").concat(currentType)] = currentType, _a["".concat(prefixCls, "-single")] = len < 2, _a)),
    supportAllEvents: true
  }, AlertGroupComponent)), currentData.map(function (item, idx) {
    var _a, _b;
    return idx + 1 === page && react_1["default"].createElement(spaui_1.Alert, __assign({
      type: (_a = item.type) !== null && _a !== void 0 ? _a : type,
      message: item.label,
      prefix: pagePosition === 'left' ? pageBar : null,
      suffix: pagePosition === 'right' ? pageBar : null,
      key: (_b = item.id) !== null && _b !== void 0 ? _b : item.value,
      onClose: function onClose() {
        if (currentData.length !== 1) {
          setCurrentData(function (d) {
            return d.filter(function (_item, index) {
              return index !== idx;
            });
          });
          if (page >= currentData.length) setPage(currentData.length - 1);
        }
      },
      closable: item.closable
    }, alertProps));
  }));
};
(0, spaui_utils_1.setComponentMark)(AlertGroupComponent, info_1["default"]);
exports["default"] = react_1["default"].memo(AlertGroupComponent);